import { useRouterState } from "@tanstack/react-router";
import { useEffect, useRef, useState } from "react";

/**
 * Announces client-side route changes to screen readers. SPA navigation is
 * otherwise silent: the URL changes but no assistive technology is told.
 */
export function RouteAnnouncer() {
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  const [message, setMessage] = useState("");
  const first = useRef(true);

  useEffect(() => {
    if (first.current) {
      first.current = false;
      return;
    }
    // Wait a tick so the new document title is committed.
    const t = window.setTimeout(() => {
      const title = document.title || pathname;
      setMessage(`Navigated to ${title}`);
    }, 120);
    return () => window.clearTimeout(t);
  }, [pathname]);

  return (
    <div aria-live="polite" aria-atomic="true" className="sr-only">
      {message}
    </div>
  );
}

export function SkipLink() {
  return (
    <a
      href="#main"
      className="skip-link"
      onClick={(e) => {
        // Move real focus into main so the next Tab continues from there.
        const target = document.getElementById("main");
        if (target) {
          e.preventDefault();
          target.setAttribute("tabindex", "-1");
          target.focus();
          target.scrollIntoView({ block: "start" });
        }
      }}
    >
      Skip to main content
    </a>
  );
}
